// src/scenes/GameOverScene.ts
//
// Phase 7 rewrite — replaces the Phase 1 stub. Renders run summary (ante /
// round reached + seed) so the player knows where they died and can share/
// re-roll the seed.

import Phaser from 'phaser';
import { addCrispText } from '../ui/textHelper';

const ROUND_LABELS = ['Small', 'Big', 'Boss'] as const;

export class GameOverScene extends Phaser.Scene {
  private seed = '';
  private ante = 1;
  private roundIndex: 0 | 1 | 2 = 0;

  constructor() {
    super({ key: 'GameOver' });
  }

  init(data: { seed?: string; ante?: number; roundIndex?: number }): void {
    this.seed = data?.seed ?? '';
    this.ante = data?.ante ?? 1;
    const ri = data?.roundIndex ?? 0;
    this.roundIndex = (ri === 1 ? 1 : ri === 2 ? 2 : 0) as 0 | 1 | 2;
  }

  create(): void {
    // Phase 17: navy background + bg-tile overlay
    this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x0d1b2a).setOrigin(0, 0);
    if (this.textures.exists('bg-tile')) {
      const tileW = 128;
      const tileH = 128;
      const cols = Math.ceil(this.scale.width / tileW) + 1;
      const rows = Math.ceil(this.scale.height / tileH) + 1;
      for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
          this.add.image(c * tileW, r * tileH, 'bg-tile').setOrigin(0, 0).setAlpha(0.08);
        }
      }
    }

    addCrispText(this, 187, 200, 'GAME OVER', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '32px',
      color: '#ffffff',
    }).setOrigin(0.5);

    const roundLabel = ROUND_LABELS[this.roundIndex];
    addCrispText(this, 187, 260, `Reached Ante ${this.ante} - ${roundLabel}`, {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '14px',
      color: '#ffffff',
    }).setOrigin(0.5);

    addCrispText(this, 187, 290, `Seed: ${this.seed}`, {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '11px',
      color: '#aaaaaa',
    }).setOrigin(0.5);

    const btn = this.add
      .rectangle(187, 400, 200, 40, 0x064020)
      .setInteractive({ useHandCursor: true });
    addCrispText(this, 187, 400, 'New Run', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '14px',
      color: '#ffffff',
    }).setOrigin(0.5);
    btn.on('pointerdown', () => this.scene.start('MenuScene'));
  }
}
